export default defineNuxtPlugin(() => {
  const { initialize } = useIssue442AbTest()
  initialize()
})
